import Button from "@vfuk/core-button/dist/Button";
import Spacing from "@vfuk/core-spacing";

import "../../assets/styles/common.scss";
import classes from "./FailureModalContent.module.scss";

export type FailureModalContentProps = {
  heading: string;
  message: string;
  body: string;
  onClose: () => void;
  onRetry?: () => void;
  closeMessage?: string;
  retryMessage?: string;
  loading?: boolean;
  errorMessage?: string;
  failedUser?: Array<{
    message: string;
    email: string;
  }>;
};

export const FailureModalContent = (
  props: FailureModalContentProps
): JSX.Element => {
  return (
    <div className={classes.FailureModalContent} role="dialog">
      <div className="modalHeading">{props.heading}</div>
      <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
        <div className="modalMessage">{props.message}</div>
      </Spacing>
      <Spacing spacingLevel={{ top: 3 }}>
        <div className="modalSubmessage">{props.body}</div>
      </Spacing>
      <br />
      <div className={classes.Buttons}>
        <div className={classes.Button}>
          <Button
            width="auto"
            appearance="primary"
            text={props.closeMessage || "Close"}
            onClick={props.onClose}
          />
        </div>
      </div>
    </div>
  );
};
